import React, { useEffect } from 'react';

// In-page image viewer for photo/ticket thumbnails: fills the viewport over
// the wizard instead of opening a new tab. Closes on the × button, a tap on
// the backdrop, or Escape. PDFs still open in a new tab (no inline viewer).
const Lightbox = ({ src, title, onClose }) => {
    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [onClose]);

    if (!src) return null;
    return (
        <div
            onClick={onClose}
            style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1000, background: 'rgba(15,23,42,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}
        >
            <img
                src={src}
                alt={title || ''}
                onClick={(e) => e.stopPropagation()}
                style={{ maxWidth: '94vw', maxHeight: '86vh', objectFit: 'contain', borderRadius: 10, boxShadow: '0 12px 40px rgba(0,0,0,0.45)', display: 'block' }}
            />
            <button
                onClick={onClose}
                title="Close"
                style={{ position: 'fixed', top: 14, right: 14, width: 40, height: 40, borderRadius: 20, border: 'none', background: 'rgba(255,255,255,0.92)', color: '#0F172A', fontSize: 20, lineHeight: 1, cursor: 'pointer', fontFamily: 'inherit', boxShadow: '0 2px 8px rgba(0,0,0,0.3)' }}
            >×</button>
            {title ? (
                <div
                    onClick={(e) => e.stopPropagation()}
                    style={{ position: 'fixed', bottom: 16, left: '50%', transform: 'translateX(-50%)', maxWidth: '86vw', background: 'rgba(15,23,42,0.75)', color: '#E2E8F0', fontSize: 12, padding: '6px 12px', borderRadius: 8, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                >{title}</div>
            ) : null}
        </div>
    );
};

export default Lightbox;
